import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import HeroSection from "../components/HeroSection";
import AboutUs from "../components/AboutUs";
import ContactUs from "../components/ContactUs";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import { FaArrowUp } from "react-icons/fa";

// Reusable Animation Variants
const animationVariants = {
  initial: { 
    opacity: 0, 
    y: 50,
    scale: 0.95
  },
  animate: { 
    opacity: 1, 
    y: 0,
    scale: 1,
    transition: {
      type: "tween",
      duration: 0.5,
      ease: "easeOut"
    }
  }
};

// Scroll To Top Button
const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!isVisible) return null;

  return (
    <motion.button
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
      onClick={scrollToTop}
      className="fixed bottom-6 right-6 bg-[#6F48E5] text-white p-3 rounded-full shadow-lg z-50"
      aria-label="Scroll to top"
    >
      <FaArrowUp />
    </motion.button>
  );
};

// Animated Section Wrapper
const AnimatedSection = ({ children, ...props }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { 
    once: false,
    amount: 0.1 
  });

  return (
    <motion.div
      ref={ref}
      variants={animationVariants}
      initial="initial"
      animate={isInView ? "animate" : "initial"}
      {...props}
    >
      {children}
    </motion.div>
  );
};

function HomePage() {
  return (
    <div className="w-full overflow-hidden">
      <div className="max-w-full">
        <AnimatedSection>
          <HeroSection />
        </AnimatedSection>

        <AnimatedSection id="about">
          <AboutUs />
        </AnimatedSection>

        <AnimatedSection id="contact">
          <ContactUs />
        </AnimatedSection>

        <AnimatedSection id="faq">
          <FAQ />
        </AnimatedSection>

        <AnimatedSection>
          <Footer />
        </AnimatedSection>

        <ScrollToTopButton />
      </div>
    </div>
  );
}

export default HomePage;